module.exports = __webpack_public_path__ + "img/interior_15.6b24bcb9.jpg";